import * as angular from "angular";
import { Field } from "../../models/field.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";

let FieldComponent = {
    selector: "vcFieldLists",
    templateUrl: "/angular/components/field/field-lists.component.html",
    bindings: {},
    controller: class FieldListController {
        public loading = false;
        public field = new Field();
        public timeoutCode: any;
        public savingFields: any;
        public fields: any;

        private readonly $timeout: any;
        private delayInMs: number;
        private $scope: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private dataProvider: FieldDataProvider;
        private activeCampaign: Campaign;

        constructor(
            $scope: any,
            $timeout: any,
            __app_type: string,
            FieldDataProvider: FieldDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.dataProvider = FieldDataProvider;
            this.$timeout = $timeout;
            this.delayInMs = __app_type == "LEADER" ? 2000 : 1000;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }

        $onInit() {
            this.dataProvider.getAllFields().then((fields) => {
                this.fields = fields;
                this.loading = false;
            });

            this.$scope.$watch(
                () => this.fields,
                (newValue, oldValue) => {
                    if (newValue && oldValue && newValue !== oldValue) {
                        this.saveFields();
                    }
                },
                true
            );
        }

        saveFields() {
            this.$timeout.cancel(this.timeoutCode); //does nothing, if timeout already done
            this.timeoutCode = this.$timeout(() => {
                if (!this.savingFields) {
                    this.savingFields = true;
                    this.dataProvider.setFields(this.fields);

                    let data = {
                        priority: this.fieldIds("priority"),
                        nonpriority: this.fieldIds("nonpriority"),
                    };

                    if (this.fields.priorityDisabled.length) {
                        data.priority = this.fieldIds(
                            "priorityDisabled"
                        ).concat(data.priority);
                    }

                    this.dataProvider.updateOrder(data).then(() => {
                        this.savingFields = false;
                        this.dataProvider.setFields(this.fields);
                    });
                }
            }, this.delayInMs);
        }

        updateField = async (field) => {
            try {
                await this.dataProvider.updateField(field);
            } catch (error: any) {
                this.toast.error();
            }
        };

        updateIcon(field: Field, icon: string): void {
            field["icon"] = icon;
            this.updateField(field);
        }

        setRequired(field: Field): void {
            if (field.required == "1" && field.readonly == "1") {
                field.readonly = "0";
            }

            this.updateField(field);
        }

        setReadOnly(field: Field): void {
            if (field.readonly == "1" && field.required == "1") {
                field.required = "0";
            }

            this.updateField(field);
        }

        onDrop(item: any): Field {
            // Remove from whichever list it came from
            ["priority", "nonpriority", "priorityDisabled"].forEach(
                (listKey) => {
                    const index = this.fields[listKey].findIndex(
                        (f) => f.id === item.id
                    );
                    if (index !== -1) {
                        this.fields[listKey].splice(index, 1);
                    }
                }
            );

            item = new Field(item);
            return item;
        }

        openFieldDialog(field: Field, ev: any): void {
            this.dialog
                .show({
                    component: "vc-custom-field-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        bindedField: field,
                    },
                })
                .then((editedField) => {
                    if (editedField) {
                        field.setData(editedField);
                    }
                });
        }

        openFieldsDirectoryDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-fields-directory",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large",
                })
                .then(() => {
                    this.dataProvider.getAllFields().then((fields) => {
                        this.fields = fields;
                    });
                });
        }

        fieldIds(type: any) {
            if (this.fields[type].length) {
                return this.fields[type].map((item) => {
                    return item["id"];
                });
            }
            return [];
        }

        deleteField(field: Field, ev: any) {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        title: `Delete ${field.name}?`,
                        bodyText: `This field and all associated data will be permanently deleted.`,
                    },
                })
                .then(() => {
                    this.dataProvider.deleteField(field).then(
                        () => this.toast.success("Field Deleted"),
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular.module("field").component(FieldComponent.selector, FieldComponent);
